// extracted by mini-css-extract-plugin
export default {"headerContainerSticky":"navigation-desktop_headerContainerSticky__CXMaj","transform-header":"navigation-desktop_transform-header__yENJN"};